export default "__VITE_ASSET__d78a5749__"